import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-close-thin",
  "use": "icon-cl-close-thin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cl-close-thin\"><path clip-rule=\"evenodd\" d=\"M3.701 3.818a1.02 1.02 0 0 0 0 1.426l6.861 6.978-6.424 6.534a1.02 1.02 0 0 0 0 1.426l.103.105a.98.98 0 0 0 1.402 0l6.425-6.534 6.289 6.396a.98.98 0 0 0 1.402 0l.103-.105a1.02 1.02 0 0 0 0-1.426l-6.289-6.396 6.726-6.84a1.02 1.02 0 0 0 0-1.427l-.103-.105a.98.98 0 0 0-1.403 0l-6.725 6.841-6.861-6.978a.98.98 0 0 0-1.403 0l-.103.105Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol